var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 9,
    viewBox: "0 0 21 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.35898L5.661 5.40998C5.76102 5.41016 5.8588 5.38033 5.9417 5.32436C6.02459 5.26838 6.08879 5.18883 6.126 5.09598L7.5 3.91344M19.5 7.87694L15.523 4.22698C15.4845 4.13101 15.4173 4.04932 15.3304 3.99317C15.2436 3.93702 15.1415 3.90916 15.0382 3.91344C14.9349 3.91771 14.8355 3.95391 14.7536 4.01705C14.6717 4.08019 14.6114 4.16716 14.581 4.26598L13.581 7.52498C13.5482 7.63123 13.481 7.72352 13.3899 7.78726C13.2987 7.85101 13.189 7.88256 13.0779 7.87694C12.9669 7.87132 12.8609 7.82884 12.7767 7.75623C12.6925 7.68361 12.6349 7.585 12.613 7.47598L11.398 1.40198C11.3761 1.29236 11.3181 1.19324 11.2332 1.12046C11.1483 1.04768 11.0415 1.00544 10.9298 1.00049C10.8182 0.99554 10.708 1.02816 10.6171 1.09315C10.5261 1.15813 10.4595 1.25172 10.428 1.35898L7.40736 3.99317",
    stroke: "#137AC9",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconGraph);
export default __webpack_public_path__ + "static/media/streamline-icon-graph.20107a64.svg";
export { ForwardRef as ReactComponent };